import { gql } from '@apollo/client';

export default gql`
  mutation redeemTicketExchanges(
    $membershipNumber: String!
    $bookingReference: String!
    $carrier: String!
    $redeemTickets: [RedeemTickets!]!
    $actionBy: String
  ) {
    redeemTicketExchanges(
      membershipNumber: $membershipNumber
      bookingReference: $bookingReference
      carrier: $carrier
      redeemTickets: $redeemTickets
      actionBy: $actionBy
    ) {
      totalPointsCost
      transactionJournalId
    }
  }
`;
